import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import StatsBar from '../components/StatsBar';
import BrandPartners from '../components/BrandPartners';
import EquipmentCategories from '../components/EquipmentCategories';
import BestSelling from '../components/BestSelling';
import BecomeDealer from '../components/BecomeDealer';
import CTA from '../components/CTA';
import Footer from '../components/Footer';
import YoutubeVideos from '../components/YoutubeVideos';

const HomePage = () => {
  return (
    <div>
      <Header />
      <main>
        <Hero />
        <StatsBar />
        <EquipmentCategories />
        <BrandPartners />
        <BestSelling />
        <YoutubeVideos />
        <BecomeDealer />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;


